import { faMegaphone } from '@fortawesome/pro-duotone-svg-icons';
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import * as Sentry from "@sentry/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChosenThemeContext } from "@ngt/forms";
import { FC, useContext, useEffect, useRef, useState } from "react";

interface IToggleFeedbackButtonProps extends Omit<IconButtonProps, 'children'> {

}

const ToggleFeedbackButton: FC<IToggleFeedbackButtonProps> = (props) => {
    const [feedback, _setFeedback] = useState(() => Sentry.getFeedback());
    const chosenTheme = useContext(ChosenThemeContext);

    const buttonRef = useRef<HTMLAnchorElement>(null);
    
    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(
                buttonRef.current, 
                { 
                    colorScheme: chosenTheme === 'dark' ? 
                        'dark' : 
                        chosenTheme === 'light' ? 
                            'light' : 
                            'system' 
                }
            );

            return () => {
                unsubscribe?.()
            }
        }
    }, [buttonRef, chosenTheme])

    return (
        <Tooltip 
            title="Report a Bug"
        >
            <IconButton
                aria-label="theme"
                color="inherit"
                ref={buttonRef as any}
                {...props}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
}


export default ToggleFeedbackButton;